const NoPage = () =>{
    return ( 
        <>
        <h1 style={{textAlign:"center",color:"red"}}>404 Error</h1>
        <p style={{textAlign:"center"}}>Something went wrong, try after some time</p>
        </>
    )
}
export default NoPage;